<template>
            <b-loading  :active.sync="loading" :can-cancel="true">
        </b-loading>
</template>

<script>
  export default {
    computed: {
      loading() {
        return this.$store.state.loading
      }
    }
  }
</script>